import * as React from "react";
import { useTheme } from "@mui/material/styles";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
const MenuProps = {
  PaperProps: {
    style: {},
  },
};

export default function MultipleSelect(props) {
  const theme = useTheme();
  const items = props.items;
  const [itemName, setItemName] = React.useState([items[0].name]);

  const [isUpdating, setIsUpdating] = React.useState(false);
  const triggerSearch = props.triggerSearch;
  let searchCriteria = props.label;

  if (searchCriteria === "Billable") {
    searchCriteria = "isBillable";
  } else if (searchCriteria === "Finalized") {
    searchCriteria = "isFinalized";
  }

  const handleChange = (item) => {
    setIsUpdating(true);

    setItemName(item.name);
    const booleanValue = JSON.parse(item.value);
    console.error(booleanValue, typeof booleanValue);

    triggerSearch(searchCriteria + ":" + booleanValue);

    setIsUpdating(false);
  };

  return isUpdating ? (
    ""
  ) : (
    <>
      <FormControl>
        <InputLabel
          id="demo-multiple-name-label"
          size="normal"
          sx={{ width: 150 }}
        >
          {props.labelText}
        </InputLabel>

        <Select
          labelId="demo-multiple-name-label"
          id="demo-multiple-name"
          value={itemName}
          defaultValue={items[0].name}
          input={<OutlinedInput label="Name" />}
          MenuProps={MenuProps}
          sx={{ width: 120, height: 50 }}
        >
          {items.map((item) => (
            <MenuItem
              key={item.name}
              value={item.name}
              style={{
                fontWeight:
                  itemName.indexOf(item.name) === -1
                    ? theme.typography.fontWeightRegular
                    : theme.typography.fontWeightMedium,
              }}
              onClick={() => handleChange(item)}
            >
              {item.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </>
  );
}
